import { red, TextField, Text } from "@flat-ui";
import { ReactSetStateFunction } from "@utils/utility-types";
import { useEffect, useState } from "react";

interface Props {
  /** The name of the workspace to be deleted */
  workspaceName: string;

  /** Setter for shouldDisableContinueButton */
  setShouldDisableContinueButton: ReactSetStateFunction<boolean>;
}

/** Content for step 3 of delete workspace */
export function DeleteWorkspaceStep3({
  workspaceName,
  setShouldDisableContinueButton,
}: Props): React.JSX.Element {
  const [text, setText] = useState<string>("");

  useEffect(() => {
    setShouldDisableContinueButton(workspaceName !== text);
  }, [workspaceName, setShouldDisableContinueButton, text]);

  return (
    <Text variant="bodyL">
      To confirm deletion, enter the workspace name{" "}
      <b style={{ color: red[400], wordBreak: "break-word" }}>
        {workspaceName}
      </b>{" "}
      below:
      <TextField
        variant="outlined"
        text={text}
        onTextChanged={setText}
        fullWidth
        sx={{ mt: 2 }}
      />
    </Text>
  );
}
